import React, {
  useState, useContext, useRef, useEffect,
} from 'react';
import { useSelector } from 'react-redux';
import { Context } from '../../Context/MenuContext';
import MenuItem from '../Common/MenuItem';
import { menuItems } from './menuConfig';

const SideNavigator = () => {
  const [toggleSideNav, setToggleSideNav, selectedMenu, setSelectedMenu, selectedSubMenu, setSelectedSubMenu] = useContext(Context);
  const mobileMenuRef = useRef(null);
  const [adminSubOpen, setAdminSubOpen] = useState(false);
  const [serviceSubOpen, setServiceSubOpen] = useState(false);
  const [userManagmentSubOpen, setUserManagmentSubOpen] = useState(false);
  const [backArrow, setBackArrow] = useState(false);

  const employeeList = useSelector((state) => state.employeeList);
  const {
    userAccess,
  } = employeeList;
  const hasAccess = (pageCode) => {
    // If pageCode is null, it means the item is accessible to all users
    if (pageCode === null) {
      return true;
    }
    if (userAccess?.length > 0) {
      return userAccess.filter((i) => i.pageCode?.toLowerCase() === pageCode?.toLowerCase() && (i.readAccess || i.writeAccess)).length > 0;
    }
    return false;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
        setToggleSideNav(false);
        setAdminSubOpen(false);
        setUserManagmentSubOpen(false);
        setServiceSubOpen(false);
        setBackArrow(false);
      }
    };
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Helper function to get the submenu open state for a given menu key
  const getSubMenuState = (menuKey) => {
    switch (menuKey) {
      case 'admin':
        return adminSubOpen;
      case 'service':
        return serviceSubOpen;
      case 'userManagement':
        return userManagmentSubOpen;
      default:
        return false;
    }
  };

  // Helper function to set the submenu open state for a given menu key
  const setSubMenuState = (menuKey, value) => {
    switch (menuKey) {
      case 'admin':
        setAdminSubOpen(value);
        break;
      case 'service':
        setServiceSubOpen(value);
        break;
      case 'userManagement':
        setUserManagmentSubOpen(value);
        break;
      default:
        break;
    }
  };

  const handleNavToggle = (menuNm) => {
    const menuItem = menuItems.find((item) => item.key === menuNm);

    if (menuNm === 'back') {
      setToggleSideNav(true);
      setBackArrow(false);
      return;
    }

    // Close all submenus first
    setAdminSubOpen(false);
    setUserManagmentSubOpen(false);
    setServiceSubOpen(false);

    if (menuItem && menuItem.subItems) {
      // This is a parent menu with submenus
      const currentState = getSubMenuState(menuNm);
      const otherMenusOpen = (menuNm !== 'admin' && adminSubOpen)
                            || (menuNm !== 'service' && serviceSubOpen)
                            || (menuNm !== 'userManagement' && userManagmentSubOpen);

      setSubMenuState(menuNm, !currentState);

      if (otherMenusOpen) {
        setToggleSideNav(false);
      }
    } else {
      // This is a simple menu item
      setSelectedSubMenu('');
      setSelectedMenu(menuNm);
    }
  };
  return (
    <>
      <div className={`sidebar  ${toggleSideNav || backArrow ? 'show shadow' : ''}`} ref={mobileMenuRef}>
        <ul className="nav flex-column">
          {menuItems.map((item) => (
            <MenuItem
              key={item.key}
              item={item}
              selectedMenu={selectedMenu}
              selectedSubMenu={selectedSubMenu}
              isSubMenuOpen={getSubMenuState(item.key)}
              hasAccess={hasAccess}
              handleNavToggle={handleNavToggle}
              setSelectedMenu={setSelectedMenu}
              setSelectedSubMenu={setSelectedSubMenu}
            />
          ))}
        </ul>
      </div>
    </>
  );
};
export default SideNavigator;
